import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NewsRoutingModule } from './news-routing.module';
import { NewsComponent } from './news.component';
import { NbButtonModule, NbCardModule, NbLayoutModule, NbMenuModule, NbRouteTabsetModule, NbSidebarModule } from '@nebular/theme';
import { ThemeModule } from '../@theme/theme.module';
import { ListComponent } from './list/list.component';
import { SingleNewsComponent } from './single-news/single-news.component';
import { SingleNewsLayoutComponent } from './single-news/single-news.layout';
import { NewsLayoutComponent } from './news.layout';
import { OtherNewsListComponent } from './other-news-list/other-news-list.component';

@NgModule({
  declarations: [
    NewsLayoutComponent,
    SingleNewsLayoutComponent,
    ListComponent,
    SingleNewsComponent,
    OtherNewsListComponent,
  ],
  imports: [
    CommonModule,
    NewsRoutingModule,
    NbSidebarModule,
    NbMenuModule,
    NbLayoutModule,
    ThemeModule,
    NbCardModule,
    NbButtonModule,
    NbRouteTabsetModule,
  ]
})
export class NewsModule { }
